import { useEffect, useRef, useState } from "react";
import styles from "./index.module.css";

const CounterSection = () => {
  const sectionRef = useRef(null);
  const [startCount, setStartCount] = useState(false);

  // Counter function
  const useCounter = (to, duration = 2000, shouldStart) => {
    const [count, setCount] = useState(0);

    useEffect(() => {
      if (!shouldStart) return; // start only when visible

      let start = 0;
      let end = to;
      let speed = duration / end;

      let timer = setInterval(() => {
        start += 1;
        setCount(start);
        if (start === end) clearInterval(timer);
      }, speed);

      return () => clearInterval(timer);
    }, [to, duration, shouldStart]);

    return count;
  };

  // Observers
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          setStartCount(true);
        }
      },
      { threshold: 0.4 } // 40% visible
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  const count1 = useCounter(500, 2000, startCount);
  const count2 = useCounter(50, 2000, startCount);
  const count3 = useCounter(100, 2000, startCount);
  const count4 = useCounter(20, 2000, startCount);

  return (
    <section className={styles.counterSection} ref={sectionRef}>
      <div className={styles.headingBox}>
        <h2>Our Key Highlights</h2>
        <p>COMMERCIAL SUCCESS</p>
      </div>

      <div className={styles.counterWrapper}>

        <div className={styles.counterItem}>
          <h3>{count1}+</h3>
          <p>ACRES OF UNFOLDED<br /> VISION</p>
        </div>

        <div className={styles.counterItem}>
          <h3>{count2}+</h3>
          <p>CONTEXTUAL & CLIMATE <br /> RESPONSIVE DESIGN</p>
        </div>

        <div className={styles.counterItem}>
          <h3>{count3}+</h3>
          <p>CRAFTING GUEST EXPERIENCES <br /> THROUGH BUILT SPACES</p>
        </div>

        <div className={styles.counterItem}>
          <h3>{count4}+</h3>
          <p>YEARS RENEWING HOSPITALITY <br /> PHILOSOPHY</p>
        </div>

      </div>
    </section>
  );
};

export default CounterSection;
